import { GET_LOCATION_URL, SEARCH_DEALERS_URL } from "@/utils/api/Urls";
import axios from "axios";

interface InstallerSearchRequest {
  address?: string;
  bounds?: MapBounds;
  latitude?: number;
  longitude?: number;
  radiusKm?: number | undefined;
  sortBy?: string;
}

interface MapBounds{
  north: google.maps.LatLng | undefined,
  south: google.maps.LatLng | undefined,
}

/**
 * Search dealers  from the server based on the provided address or coordinates.
 * @param address
 * @param coordinates
 * @param sortBy
 * @returns dealers
 */
export const searchDealers = async (address: string, coordinates?: { latitude: number; longitude: number, bounds: google.maps.LatLngBounds | undefined }, sortBy?: string, radiusKm?: number) => {
  const requestURL = `${SEARCH_DEALERS_URL}`;

  const ne = coordinates?.bounds?.getNorthEast()
  const sw = coordinates?.bounds?.getSouthWest()

  const requestData: InstallerSearchRequest = {
    address: address,
    bounds:{ north: ne , south: sw},
    ...(radiusKm && { radiusKm: radiusKm }),
    ...(coordinates && { latitude: coordinates.latitude, longitude: coordinates.longitude }),
    ...(sortBy && { sortBy: sortBy })
  };

  try {
    const response = await axios.post(requestURL, requestData);
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      if (err.response) {
        console.log("Error status:", err.response.status);
        return;
      }

      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }
    console.log("Error occurred:", err);
  }
}; 

/**
 * Get latitude and longitude from address using the getLocation endpoint.
 * @param address The address string to geocode.
 * @returns latitude and longitude, or undefined on error.
 */
export const getLocation = async (address: string) => {
  const requestUrl= `${GET_LOCATION_URL}`;
  try {
    const response = await axios.post(requestUrl, { address });
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      if (err.response) {
        console.log("Error status:", err.response.status);
        return;
      }
      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }
    console.log("Error occurred:", err);
  }
};
